<ng-container *ngIf="customerService.customer.value.loyalty">
	<div class="d-flex flex-wrap">
		<div class="d-flex card flex-fill flex-column m-2">
			<div class="m-2">Account ID: {{ customerService.customer.value.loyalty.AcctNo }}</div>
			<div class="m-2">Account Name {{ customerService.customer.value.loyalty.FirstName }} {{ customerService.customer.value.loyalty.LastName }}</div>
		</div>
		<div class="d-flex card flex-fill flex-column m-2">
			<div class="d-flex m-2">
				<div>Loyalty Status:</div>
				<fa-icon *ngIf="customerService.customer.value.loyalty.LoyaltyStatus === 'Activated'" class="ms-3" [icon]="['far', 'check']"> </fa-icon>
				<fa-icon *ngIf="customerService.customer.value.loyalty.LoyaltyStatus !== 'Activated'" class="ms-3" [icon]="['far', 'times']"> </fa-icon>
			</div>
			<div class="m-2">Loyalty Gift Card Balance {{ customerService.customer.value.loyalty.GCBalance | currency }}</div>
		</div>
	</div>

	<div class="d-flex flex-wrap">
		<div *ngFor="let plan of customerService.customer.value.loyalty.Plan" class="m-2 card flex-fill">
			<div class="d-flex">
				<div class="m-2 h4">{{ plan.PlanName }}</div>
			</div>
			<div class="d-flex">
				<div class="m-2">{{ plan.PlanValue }} {{ plan.PlanMeasurement }}</div>
			</div>
			<div class="m-2">Available Discounts</div>
			<div *ngFor="let rec of plan.Discounts?.Discount">
				<div class="d-flex ms-4">{{ rec.DiscountCount }} {{ rec.DiscountName }}</div>
			</div>
		</div>
	</div>
</ng-container>
